'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { OUTAGE_REASONS } from '../constants/outageReasons.constants';
import ServiceAvailabilityStatusPropType from '../propTypes/ServiceAvailabilityStatusPropType';
import makeMessageKeyUtil from '../utils/makeMessageKeyUtil.util';
const messageKeyUtil = makeMessageKeyUtil(`fintech-outage-banner.message`);

const getMessageJsxKey = key => `${messageKeyUtil(key)}_jsx`;

const FintechOutagesBannerMessage = ({
  serviceAvailabilityStatus
}) => {
  const reason = (serviceAvailabilityStatus || {}).outageReason;
  const endTime = (serviceAvailabilityStatus || {}).outageEndTime;

  if (reason === OUTAGE_REASONS.PLANNED_OUTAGE) {
    if (endTime && endTime > new Date().getTime()) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: getMessageJsxKey('planned-with-end'),
        options: {
          outageEndTime: endTime
        },
        elements: {
          DateTime: FormattedDateTime
        }
      });
    }

    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKeyUtil('planned')
    });
  }

  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: messageKeyUtil('unplanned')
  });
};

FintechOutagesBannerMessage.propTypes = {
  serviceAvailabilityStatus: ServiceAvailabilityStatusPropType.isRequired
};
export default FintechOutagesBannerMessage;